module.exports = __webpack_public_path__ + "static/media/business-outline.6219d738.svg";